import { BaseEntity } from "./BaseEntity";

export class AttributeEntity extends BaseEntity {
    constructor() {
        super();

        this.entityName = "components.isp.attributeList.attribute";
        this.pageTitle = "components.settings.permissionManagement.menuList.Attribute";
        this.menuPath = "/ISP";
        this.APIRoute = "Resources/ISP/Attribute"
        this.i18nBase = "components.isp.attribute";
        this.baseEndPoint = "radius/attribute";
        this.endpoints = {
            list: `${this.baseEndPoint}`,
            create: `${this.baseEndPoint}`,
            get: `${this.baseEndPoint}/:id`,
            delete: `${this.baseEndPoint}/:id`,
            activate: `${this.baseEndPoint}/:id/activate`,
            deactivate: `${this.baseEndPoint}/:id/deactivate`
        };

        this.fields = [
            {
                key: "id",
                label: "user.fields.id",
                type: "text",
                visible: false,
                editable: false,
                orderBy: false
            },
            {
                key: "name",
                label: "common.labels.name",
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "name"
            },
            {
                key: "default_value",
                label: "components.isp.layout.value",
                type: "combobox",
                multiple: true,
                visible: true,
                required: true,
                editable: true,
                source: "varTemplatesList",
                itemTitle: "name",
                itemValue: "name",
                path: "default_value",
                options: [],
                cols:6
            },
            {
                key: "description",
                label: "common.labels.description",
                type: "textarea",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "description"
            },
            {
                key: "manufacturer_id",
                label: "components.isp.manufacturerList.manufacturer",
                type: "autocomplete",
                visible: true,
                required: true,
                editable: true,
                searchHandler: "handleSearchManufacturer",
                options: [],
                path: "manufacturer_id",
                cols:6
            },
            {
                key: "status",
                label: null,
                type: "activeSwitch",
                visible: true,
                required: true,
                editable: true,
                orderBy: false,
                cols: 12,
                path:"status"
            },
        ]

        this.customActions = {
            duplicate: false
        }

        this.tableColumns = [
            {
                key: "name",
                label: "common.labels.name",
                visible: true,
                orderBy: true
            },
            {
                key:"manufacturer",
                orderByKey: "manufacturer.name",
                label: "components.isp.manufacturerList.manufacturer",
                visible: true,
                orderBy: true
            },
            {
                key: "status",
                label: "common.labels.status",
                visible: true,
                orderBy: true
            },
            {
                key: "actions",
                label: "common.labels.actions",
                visible: true,
                orderBy: false
            },
        ]

        this.pages = {
            edit: {
                pageTitle: `${this.i18nBase}.pageTitleEdit`,
                pathI18n: `components.settings.permissionManagement.menuList.ISP/components.settings.permissionManagement.menuList.Attribute`,
                route: ["/isp","/isp/attribute", "/isp/attribute/edit/:id"]
            },
            create: {
                pageTitle: `${this.i18nBase}.pageTitle`,
                pathI18n: `components.settings.permissionManagement.menuList.ISP/components.settings.permissionManagement.menuList.Attribute`,
                route: ["/isp","/isp/attribute", "/isp/attribute/create"]
            },
            list: {
                pageTitle: `components.settings.permissionManagement.menuList.Attribute`,
                pathI18n: `components.settings.permissionManagement.menuList.ISP`,
                route: ["/isp"],
                filters: {
                    quickSearch: {
                        info: "common.messages.info.searchByName",
                        searchBy: ["name"],
                        type: "text",
                    },
                    advanced: {
                        fields: [
                            {
                                key: "status",
                                label: "common.labels.status",
                                type: "select",
                                options: [
                                    { label: "common.labels.active", value: true },
                                    { label: "common.labels.inactive", value: false },
                                ],
                                path:"status"
                            },
                            {
                                key: "manufacturer_name",
                                label: "components.isp.manufacturerList.manufacturer",
                                type: "autocomplete",
                                visible: true,
                                editable: true,
                                searchHandler: "handleSearchManufacturer",
                                options: [],
                                path: "manufacturer_name",
                                itemTitle: "title",
                                itemValue: "title",
                            },
                        ],
                    },
                },
            },
        };
    }

    getUrl(endpoint, params = {}) {
        let url = endpoint;
        Object.keys(params).forEach(key => {
            url = url.replace(`:${key}`, params[key]);
        });
        return url;
    }
}
